import {
  SOCIAL_REQUEST,
  DEFINE_USER_COORDINATES_REQUEST,
  SIGNUP_REQUEST,
  LOGIN_REQUEST,
  FETCH_USER_REQUEST,
  LOGOUT_REQUEST,
  RETRIEVE_PASSWORD_REQUEST,
  UPLOAD_AVATAR_REQUEST,
  REMOVE_AVATAR_REQUEST,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST,
  CANCEL_SUBSCRIPTION_REQUEST,
  ADD_CREDIT_REQUEST,
} from '../types';

export const updateUserProfile = values => ({ type: UPDATE_PROFILE_REQUEST, payload: values });

export const updateUserPassword = values => ({ type: UPDATE_PASSWORD_REQUEST, payload: values });

export const uploadUserAvatar = formData => ({ type: UPLOAD_AVATAR_REQUEST, payload: formData });

export const removeUserAvatar = () => ({ type: REMOVE_AVATAR_REQUEST });

export const getUserFromSocial = (code, type) => ({ type: SOCIAL_REQUEST, payload: { code, type }});

export const defineUserCoordinates = () => ({ type: DEFINE_USER_COORDINATES_REQUEST });

export const handleRegistration = email => ({ type: SIGNUP_REQUEST, payload: email });

export const handleLogin = (formData, remember) => ({ type: LOGIN_REQUEST, payload: { formData, remember } });

export const updateUserSession = ctx => ({ type: FETCH_USER_REQUEST, payload: ctx });

export const handleLogout = () => ({ type: LOGOUT_REQUEST });

export const handleForgotPassword = email => ({ type: RETRIEVE_PASSWORD_REQUEST, payload: email });

export const handleResetPassword = (newPassword, resetToken) => ({ type: RESET_PASSWORD_REQUEST, payload: { resetToken, newPassword } });

export const cancelSubscription = () => ({ type: CANCEL_SUBSCRIPTION_REQUEST });

export const handleAddCredit = promoCode => ({ type: ADD_CREDIT_REQUEST, payload: { promoCode } });
